import { Box, Button, Stack, Typography } from "@mui/material";
import { ReactNode } from "react";
import { sendWhatsappMessage } from "../../../../shared/helpers/MessageHelper";
import { useTranslation } from "react-i18next";
import i18n from "../../../../i18n";
import i18next from "i18next";
interface Contact {
  icon: ReactNode;
  label: string;
  value: string;
}
export const ContactUsForm: React.FC<{ Contacts: Contact[] }> = (props) => {
  const contactInfo = props.Contacts;
  const { t } = useTranslation();
  return (
    <Box
      flex={1}
      sx={{
        display: "flex",
        flexDirection: "column",
        maxHeight: "32rem", // Responsive height
        gap: "2rem",
        px: "1.5rem",
        py: "1rem",
        border: 1,
        borderColor: "#E3E3E3",
      }}
    >
      <Stack spacing={0}>
        <Typography
          fontFamily={i18next.language === "ar" ? "Somar" : "DM Sans"}
          variant="body1"
          color="text.primary"
          align="justify"
        >
          {t("contact_us")}
        </Typography>

        <Typography
          fontFamily={i18next.language === "ar" ? "Somar" : "DM Sans"}
          sx={{
            width: "90%",

            fontSize: {
              xs: "1.5rem", // Extra small screens (typically mobile devices)
              sm: "2.5rem", // Small screens (e.g., tablets)
              md: "2rem", // Medium screens (e.g., small laptops)
              lg: "2rem", // Large screens (e.g., desktop)
              xl: "2rem", // Extra large screens (large desktops)
              xxl: "2rem", // Extra extra large screens (very large displays)
            },
          }}
          align={i18n.language === "ar" ? "right" : "left"}
          fontWeight="bold"
          color="text.primary"
        >
          {t("contact_us_subtitle")}
        </Typography>
      </Stack>

      <Stack spacing={3}>
        {contactInfo.map((item, index) => (
          <Stack key={index} direction="row" spacing={2} alignItems="center">
            <Box
              sx={{
                color: "warning.main",
                paddingInline: 1.5,
              }}
            >
              {item.icon}
            </Box>
            <Box>
              <Typography
                fontFamily={i18next.language === "ar" ? "Somar" : "DM Sans"}
                align="justify"
                fontWeight="400"
                color="#818181"
              >
                {item.label}
              </Typography>
              <Typography
                fontFamily={i18next.language === "ar" ? "Somar" : "DM Sans"}
                align="justify"
                fontWeight="400"
                style={{ direction: "ltr" }}
                variant="body1"
                color="#1B1B1B"
              >
                {item.value}
              </Typography>
            </Box>
          </Stack>
        ))}
      </Stack>

      <Button
        variant="contained"
        onClick={() =>
          sendWhatsappMessage("Hello, I would like to get in touch.")
        }
        sx={{
          bgcolor: "#1b1b1b",
          color: "white",
          borderRadius: 0,
          fontSize: "1rem",
          fontFamily: i18next.language === "ar" ? "Somar" : "DM Sans",
          py: ".8rem",
          px: "1rem",
          fontWeight: 500,
          textTransform: "none",
          alignSelf: "flex-start",
        }}
      >
        {t("contact_whatsapp_button")}
      </Button>
    </Box>
  );
};
